var React = require('react');

function BreathMainSliderPrevBtn (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.430067 8.14688C-0.0410957 8.61804 -0.0410958 9.38195 0.430067 9.85312L8.10812 17.5312C8.57928 18.0023 9.34319 18.0023 9.81435 17.5312C10.2855 17.06 10.2855 16.2961 9.81435 15.8249L2.98942 9L9.81436 2.17506C10.2855 1.7039 10.2855 0.939991 9.81436 0.468828C9.34319 -0.00233579 8.57929 -0.00233586 8.10812 0.468828L0.430067 8.14688ZM23 7.79351L1.28318 7.79351L1.28318 10.2065L23 10.2065L23 7.79351Z","fill":"black"}));
}

BreathMainSliderPrevBtn.defaultProps = {"width":"23","height":"18","viewBox":"0 0 23 18","fill":"none"};

module.exports = BreathMainSliderPrevBtn;

BreathMainSliderPrevBtn.default = BreathMainSliderPrevBtn;
